import axios from "axios";

const api = axios.create({
  withCredentials: true,
});

api.interceptors.response.use(null, function(err) {
  if (err.response.status === 401) {
    window.location.reload();
  }
  return Promise.reject(err);
});

export default api;
